import React from "react";
import { useNavigate } from "react-router-dom";
import './NotFound.scss';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <h1>404</h1>
                <p>Oops! The page you are looking for doesn’t exist.</p>
                <button className="back-button" onClick={() => window.open('https://www.dafabet.com/en', '_blank')}>
                    Go Back to Home
                </button>
            </div>
        </div>
    );
};

export default NotFound;
